<template>
  <b-modal id="collapseuserinfo"  :title="$te('VMX.user_information_showuserinfo') ? $t('VMX.user_information_showuserinfo') : 'User Information'" hide-footer centered>
      <div v-if="showAccessDenyInformation" class="no-access-reasons-container">
        <p><strong> {{$te('VMX.user_information_headline') ? $t('VMX.user_information_headline') : 'Currently our system holds the following information for your account:'}}</strong></p>
        <div class="user-information-flex" v-if="displayUserQRCode && testQRCode">
          <section
            @click="isQRCodeVisible = !isQRCodeVisible"
            :aria-expanded="qrCodeOptions ? 'true' : 'false'" aria-controls="qr-code-options"
            class="qr-code-option-container">
            <span
              v-html="$te('VMX.qr_code_section_label') ? $t('VMX.qr_code_section_label') : 'QR Code'"
            />
            <span>
              <font-awesome-icon
                class="filter-toggle-chevron-icon"
                :icon="isQRCodeVisible
                  ? ['fas', 'chevron-down']
                  : ['fas', 'chevron-right']
                " />
            </span>
          </section>
          <b-collapse
            v-model="isQRCodeVisible"
            id="qr-code-option">
            <img :src="testQRCode" alt="user-qr-code" />
          </b-collapse>
        </div>
        <div class="user-information-flex">
          <span class="participant-type__label" style="font-weight: bold;">
            <font-awesome-icon :icon="['fas', 'user']" />
            {{$te('VMX.user_information_participanttype') ? $t('VMX.user_information_participanttype') : 'Participant Type: '}}
          </span>
          <span
            class="participant-type__type" v-if="participanttype !== 'null'" v-html="participanttype" />
            <span
            class="participant-type__type" v-else>{{$te('VMX.user_information_participanttype') ? $t('VMX.user_information_participanttype') : 'No participant type'}}
          </span>
        </div>
        <div class="user-information-flex">
          <span class="ticket-type__label" style="font-weight: bold;">
            <font-awesome-icon :icon="['fas', 'credit-card']" />
            {{$te('VMX.user_information_ticketsheadline') ? $t('VMX.user_information_ticketsheadline') : 'Ticket(s): '}}
          </span>
          <span v-if="tickets" class="ticket-type__types-container">
            <span class="ticket-type__types" v-for="(ticket, idx) in tickets" :key="idx">
              <span v-html="ticket" />
            </span>
          </span>
          <span v-else>
           {{$te('VMX.user_information_noticket') ? $t('VMX.user_information_noticket') : 'No Tickets'}}
          </span>
        </div>
        <div>
          <span class="hcp-status" v-if="hcp">
            <strong><font-awesome-icon :icon="['fas', 'check-circle']" />{{$te('VMX.user_information_userishcp') ? $t('VMX.user_information_userishcp') : 'You are authorised to prescribe medication.'}}</strong>
          </span>
          <span v-else class="hcp-status">
            <strong><font-awesome-icon :icon="['fas', 'circle']" /> {{$te('VMX.user_information_userisnothcp') ? $t('VMX.user_information_userisnothcp') : 'You are not authorised to prescribe medication.'}}</strong>
          </span>
        </div>
      </div>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      tickets: null,
      participanttype: null,
      hcp: null,
      userInformationOpen: true,
      isQRCodeVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
      userData: 'user/user',
      instance: 'instancesState/getInstance',
      userTicket: 'userTicket/userTicket',
    }),
    config() {
      return this.configForKey('app_config').config[0]
    },
    showAccessDenyInformation() {
      return 'showAccessDenyInformation' in this.config.defaults ? this.config.defaults.showAccessDenyInformation : true
    },
    qrCodeOptions() {
      return 'qrCodeOptions' in this.config.defaults ? this.config.defaults.qrCodeOptions : true
    },
    displayUserQRCode() {
      return 'displayUserQRCode' in this.config.defaults ? this.config.defaults.displayUserQRCode : true
    },
    testQRCode() {
      return 'testQRCode' in this.config.defaults ? this.config.defaults.testQRCode : null
    },
  },
  async mounted() {
    if (this.showAccessDenyInformation) {
      this.participanttype = this.$cookies.get('participant_type') || null
      this.hcp = this.$cookies.get('hcp') ? JSON.parse(this.$cookies.get('hcp')) : null
      this.tickets = this.$cookies.get('tickets') ? this.$cookies.get('tickets').split(';')
        .map(item => item.replace('manage_admission_valid_booked_ticket|', ''))
        .filter(item => item.trim() !== '') : null
    }
  },
}
</script>
<style>

.no-access-reasons-container {
  display: flex;
  flex-direction: column;
  gap: .5rem;
}
.no-access-reasons-container > p {
  margin: 0;
}
.user-information-flex {
  display: flex;
  flex-direction: column;
  gap: .25rem;
}
.section-toogle-container {
  background: #fff;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-card__show-information {
  font-size: 1rem;
  color: var(--primary);
}
.ticket-type__types-container {
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
}
.ticket-type__types {
  border: 1px solid var(--primary);
  border-radius: .25rem;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: .25rem .5rem;
}

.qr-code-option-container {
  cursor: pointer;
}
</style>
